import { render, staticRenderFns } from "./ComponentWhitelistConfig.vue?vue&type=template&id=7db3ff83"
import script from "./ComponentWhitelistConfig.vue?vue&type=script&lang=js"
export * from "./ComponentWhitelistConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports